import { useState } from "react";

import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { Panel } from "primereact/panel";

import { useReport } from "../../context/report";
import { FilterMatchMode } from "primereact/api";

export default function ConsumoFio() {
    const [filters, setFilters] = useState({
        "artigo": { matchMode: FilterMatchMode.EQUALS, value: "" }
    });

    const { data } = useReport();

    const formatNumber = (rowData, props) => {
        return Intl.NumberFormat("pt-BR", { maximumFractionDigits: 0 }).format(rowData[props.field]);
    }

    return (
        <div>
            <div className="p-d-flex p-flex-row p-jc-end p-mb-2">
                <InputText
                    onChange={e => {
                        let _filters = {...filters};
                        _filters.artigo.value = e.target.value;
                        setFilters(_filters);
                    }}
                    placeholder=""
                    value={filters.artigo.value}
                />
            </div>
            <Panel
                collapsed
                header="CONSUMO DE TRAMA E URDUME POR GRUPO DE MAQUINAS"
                toggleable
            >
                <DataTable
                    filters={filters}
                    responsiveLayout="scroll"
                    size="small"
                    value={data.artigos}
                >
                    <Column header="Artigo" field="artigo" sortable />
                    <Column header="Trama" field="trama1" sortable />
                    <Column header="Urdume" field="urdume1" sortable />
                    <Column header="Picanol" field="producao_picanol" body={formatNumber} sortable />
                    <Column header="Consumo Trama" field="consumotrama1_picanol" body={formatNumber} sortable />
                    <Column header="Consumo Urdume" field="consumourdume1_picanol" body={formatNumber} sortable />
                    <Column header="Toyota" field="producao_toyota" body={formatNumber} sortable />
                    <Column header="Consumo Trama" field="consumotrama1_toyota" body={formatNumber} sortable />
                    <Column header="Consumo Urdume" field="consumourdume1_toyota" body={formatNumber} sortable />
                </DataTable>
            </Panel>

            <Panel
                collapsed
                header="CONSUMO POR TRAMA"
                toggleable
            >
                <DataTable
                    responsiveLayout="scroll"
                    size="small"
                    value={data.tramas}
                >
                    <Column header="Trama" field="trama" sortable />
                    <Column header="Consumo" field="consumo" body={formatNumber} sortable />
                </DataTable>
            </Panel>

            <Panel
                collapsed
                header="METROS TOTAL"
                toggleable
            >
                <DataTable
                    filters={filters}
                    responsiveLayout="scroll"
                    size="small"
                    value={data.artigo_maquinas}
                >
                    <Column header="Artigo" field="artigo" body={formatNumber} sortable />
                    <Column header="Picanol" field="picanol" body={formatNumber} sortable />
                    <Column header="Toyota" field="toyota" body={formatNumber} sortable />
                    <Column header="Total" field="total" body={formatNumber} sortable />
                </DataTable>
            </Panel>
        </div>
    )
}